"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const namespaces_1 = require("../namespaces");
const apiDocumentation_1 = require("./apiDocumentation");
const collection_1 = require("./collection");
const linksAndOperations_1 = require("./linksAndOperations");
const linksExtractor_1 = require("./linksExtractor");
const rdfSchema_1 = require("./rdfSchema");
const templatedOperationsExtractor_1 = require("./templatedOperationsExtractor");
/**
 * Provides simple property mappings to be used when creating resources.
 * @const
 * @type {IDictionary<IPropertyMapping>}
 */
exports.mappings = {};
rdfSchema_1.rdfSchema(exports.mappings);
apiDocumentation_1.apiDocumentation(exports.mappings);
linksAndOperations_1.linksAndOperations(exports.mappings);
collection_1.collection(exports.mappings);
exports.mappings[namespaces_1.hydra.required] = {
    default: false,
    propertyName: "required",
    required: true,
    type: [namespaces_1.hydra.SupportedProperty, namespaces_1.hydra.IriTemplateMapping]
};
exports.mappings[namespaces_1.hydra.subject] = {
    default: subjects => subjects[0] || null,
    propertyName: "subject"
};
exports.mappings[namespaces_1.hydra.property] = {
    default: properties => properties[0] || null,
    propertyName: "property"
};
exports.mappings[namespaces_1.hydra.object] = {
    default: objects => objects[0] || null,
    propertyName: "object"
};
exports.mappings[namespaces_1.hydra.operation] = {
    default: templatedOperationsExtractor_1.templatedOperationsExtractor,
    propertyName: "operations",
    required: true
};
exports.mappings[namespaces_1.hydra.title] = {
    default: "",
    propertyName: "displayName",
    required: true,
    type: [
        namespaces_1.hydra.Class,
        namespaces_1.hydra.ApiDocumentation,
        namespaces_1.hydra.Link,
        namespaces_1.hydra.Operation,
        namespaces_1.hydra.SupportedProperty
    ]
};
exports.mappings[namespaces_1.hydra.description] = {
    default: "",
    propertyName: "description",
    required: true,
    type: [
        namespaces_1.hydra.Class,
        namespaces_1.hydra.ApiDocumentation,
        namespaces_1.hydra.Link,
        namespaces_1.hydra.Operation,
        namespaces_1.hydra.SupportedProperty
    ]
};
exports.mappings.links = {
    default: linksExtractor_1.linksExtractor,
    propertyName: "links",
    required: true
};
//# sourceMappingURL=mappings.js.map